<template>
    <DashboardLayout ref="dashboardLayout">
        <div class="flex flex-column" style="min-height: calc(100vh - 90px);">
        <Breadcrumb class="flex breadcrumb" :model="items" />
        <div class="card flex flex-column justify-center pt-4 px-4">
            <div v-if="viewStack.length > 1" class="mb-4">
                <Button label="Back" icon="pi pi-arrow-left" class="p-button-text back-button cursor-pointer "
                    @click="goBack" />
            </div>
            <div v-if="currentView.type === 'list' && (Tutors && Tutors.length)">
                <TutorList :tutors="Tutors" @view-tutor="pushView('profile', $event)" @open-chat="handleOpenChat" />
            </div>
            <div v-else-if="currentView.type === 'profile'">
                <TutorProfile :tutorId="currentView.data.tutorId" @view-class="pushView('RequestClass', $event)"
                    @classes-ended="handleClassesEnded" @open-chat="handleOpenChat" />
            </div>
            <div v-else-if="currentView.type === 'RequestClass'">
                <!-- <RequestClass :classes="classes" :modules="modules" /> -->
                <RequestClass :inner-useage="true" :tutor="currentView.data._id" />
            </div>
            <div v-else class="flex align-item-center justify-content-center h-full">
                <div class="flex flex-column ">
                    <span class="Caption text-gray-700 text-center"> You don’t have any Enrolled tutors yet,
                        please schedule a class with a tutor to get enrolled</span>
                </div>
            </div>
        </div>

        <!-- Notice -->
        <div v-if="currentView.type === 'list'" class="text-center w-full max-w-xl mx-auto py-4 px-6 mt-auto">
            <h3 class="text-lg font-semibold mb-2" style="color: #dc2626;">NOTICE</h3>
            <p class="text-700 text-sm m-0">
                If a student and tutor do not schedule any classes after enrollment, the enrollment may be automatically removed due to inactivity.
            </p>
        </div>

        </div>
    </DashboardLayout>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import Breadcrumb from 'primevue/breadcrumb';
import Button from "primevue/button";
import TutorList from '@/components/dashboard/student/enrolledTutors/tutorList.vue'
import TutorProfile from '@/components/dashboard/student/enrolledTutors/tutorProfile.vue'
// import RequestClass from '@/components/dashboard/tutor/classRequests/scheduleClass.vue'
import DashboardLayout from "@/layout/DashboardLayout.vue";
import { fetchEnrolledTutors } from "@/api/student";
import RequestClass from "../RequestClass.vue";


const Tutors = ref([]);
// const classes = [
//     { subject: "Mathematics", classType: "Physical", location: "At Tutor’s place", classDate: "2025.04.30", classTime: "3 P.M. - 5 P.M." },
//     { subject: "Mathematics", classType: "Physical", location: "At Tutor’s place", classDate: "2025.04.30", classTime: "3 P.M. - 5 P.M." },
//     { subject: "Mathematics", classType: "Physical", location: "At Tutor’s place", classDate: "2025.04.30", classTime: "3 P.M. - 5 P.M." },

// ];

// const modules = [
//     "History", "English"
// ]
const viewStack = ref([
    { type: "list", label: "Enrolled Tutors", data: null }
]);
const items = computed(() => {
    return [
        { label: "Dashboard" },
        ...viewStack.value.map(v => ({ label: v.label }))
    ];
});
const currentView = computed(() =>
    viewStack.value[viewStack.value.length - 1]
);
function pushView(type, data) {
    if (type === "profile") {
        viewStack.value.push({ type, label: data.TutorName, data });
    } else {
        viewStack.value.push({ type, label: "Request New Class", data });
    }
}
function goBack() {
    if (viewStack.value.length > 1) {
        viewStack.value.pop();
    }
}

const handleClassesEnded = async () => {
    goBack();
    await fetchTutors();
}

const fetchTutors = async () => {
    const tutors = await fetchEnrolledTutors();
    Tutors.value = tutors.data.data;
}
onMounted(() => {
    fetchTutors();
})

const dashboardLayout = ref(null);

const handleOpenChat = (channel) => {
    if (dashboardLayout.value) {
        if (channel && typeof dashboardLayout.value.openSelectedChat === 'function') {
            dashboardLayout.value.openSelectedChat(channel);
        } else if (typeof dashboardLayout.value.openChatList === 'function') {
            dashboardLayout.value.openChatList();
        }
    }
}
</script>
<style scoped>
.back-button {
    color: var(--gray-600);
}

.back-button:hover {
    color: var(--gray-600) !important;
    background-color: var(--gray-200) !important;
}

.back-button:active {
    color: var(--gray-600) !important;
}

.navigation {
    display: flex !important;
    flex-wrap: wrap !important;
    display: inline-block;
    padding: 10px;
}

.breadcrumb {
    display: flex !important;
    flex-wrap: wrap !important;
    overflow-x: hidden !important;
}

.text-gray-700 {
    color: var(--gray-700) !important;
    padding-top: 30vh;
}

@media (max-width: 767px) {
    .breadcrumb {
        font-size: 12px;

    }
}
</style>